import { PageElement } from "./PageElement";

export default PageElement;
